import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Modal } from "react-bootstrap";
import { FaArrowLeft, FaShareAlt, FaWhatsapp, FaFacebook, FaFacebookMessenger } from "react-icons/fa";
import Navbar from "../dashboard/navbar";
import Sidebar from "../dashboard/sidebar";
import useAuth from "../dashboard/useAuth";
import { useMediaQuery } from "react-responsive";
import { QRCodeCanvas } from 'qrcode.react';

const InfoAchat = ({ titre }) => {
  
  const { id } = useParams();
  const navigate = useNavigate();
  const [achat, setAchat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showShareModal, setShowShareModal] = useState(false);
  const [qrCodeData, setQrCodeData] = useState("");
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const user_id = localStorage.getItem("IDDDD");

  useEffect(() => {
    document.title = "PayMe | Détails de l'achat";

    const fetchAchat = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_HOTE}/achat-qr-code/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        setAchat(response.data);
        setQrCodeData(response.data.qr_code_url || `${process.env.REACT_APP_HOTE}/achat-qr-code/${id}`);
      } catch (error) {
        console.error("Erreur lors de la récupération des détails de l'achat:", error);
        navigate("/mes-achats", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchAchat();
    } else {
      navigate("/achats", { replace: true });
    }
  }, [id, navigate]);

  const handleShareClick = () => {
    setShowShareModal(true);
  };

  return (
    <div>
      <style>
        {`
          body {
            background-color: #f3f4f6;
            font-family: 'Arial', sans-serif;
          }
          .page-container {
            min-height: 100vh;
            margin-left: ${user_id ? '256px' : '0'};
            transition: margin-left 0.3s ease;
          }
          .content-wrapper {
            max-width: 960px;
            margin: 0 auto;
            padding: 24px;
          }
          .card {
            background-color: #ffffff;
            border-radius: 12px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            overflow: hidden;
          }
          .card-header {
            background: linear-gradient(to right, #3b82f6, #2563eb);
            padding: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .card-header h2 {
            color: #ffffff;
            font-size: 20px;
            font cairo-semibold;
            margin: 0;
          }
          .card-content {
            padding: 24px;
          }
          .mobile-section, .desktop-section {
            background-color: #f9fafb;
            border-radius: 8px;
            padding: 16px;
          }
          .mobile-section .item, .desktop-section .item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            font-size: 14px;
          }
          .mobile-section .item:last-child, .desktop-section .item:last-child {
            margin-bottom: 0;
          }
          .item-label {
            color: #6b7280;
            font-weight: 500;
          }
          .item-value {
            color: #1f2937;
            font-weight: 600;
            max-width: 60%;
            word-wrap: break-word;
          }
          .item-value.green {
            color: #16a34a;
          }
          .item-value.blue {
            color: #2563eb;
          }
          .item-value.badge {
            background-color: #3b82f6;
            color: #ffffff;
            padding: 4px 12px;
            border-radius: 9999px;
            font-size: 12px;
          }
          .desktop-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;
          }
          .button {
            padding: 8px 16px;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
          }
          .button-primary {
            background-color: #3b82f6;
            color: #ffffff;
            border: none;
          }
          .button-primary:hover {
            background-color: #2563eb;
            transform: translateY(-1px);
          }
          .button-secondary {
            background-color: #ffffff;
            color: #3b82f6;
            border: 1px solid #3b82f6;
          }
          .button-secondary:hover {
            background-color: #f3f4f6;
            transform: translateY(-1px);
          }
          .loading-container {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
          }
          .spinner {
            width: 48px;
            height: 48px;
            border: 4px solid #3b82f6;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          .error-container {
            max-width: 960px;
            margin: 24px auto;
            padding: 16px;
            background-color: #fef3c7;
            border: 1px solid #fde68a;
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          }
          .error-container p {
            color: #b45309;
            margin: 0 0 12px 0;
          }
          .qr-code-container {
            display: flex;
            justify-content: center;
            margin-top: 24px;
          }
          .modal-body {
            display: flex;
            justify-content: space-around;
            padding: 24px;
          }
          .social-link {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            transition: color 0.3s ease;
          }
          .social-link span {
            margin-top: 8px;
            font-size: 12px;
          }
          .social-link.whatsapp {
            color: #25D366;
          }
          .social-link.whatsapp:hover {
            color: #1DA851;
          }
          .social-link.facebook {
            color: #3b5998;
          }
          .social-link.facebook:hover {
            color: #2f477a;
          }
          .social-link.messenger {
            color: #0084ff;
          }
          .social-link.messenger:hover {
            color: #006cd9;
          }
          @media (max-width: 767px) {
            .page-container {
              margin-left: 0;
            }
            .card-header h2 {
              text-align: center;
              width: 100%;
            }
            .desktop-section {
              display: none;
            }
          }
          @media (min-width: 768px) {
            .mobile-section {
              display: none;
            }
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="page-container">
       
        <div>
          
          <div className="content-wrapper">
            {loading ? (
              <div className="loading-container">
                <div className="spinner"></div>
              </div>
            ) : !achat ? (
              <div className="error-container">
                <p>Achat non trouvé.</p>
                <button className="button button-secondary" onClick={() => navigate(-1)}>
                  Retour
                </button>
              </div>
            ) : (
              <div className="card">
                <div className="card-header">
                  {isMobile ? (
                    <h2>Détails de l'achat</h2>
                  ) : (
                    <>
                      <h2>Détails de l'achat</h2>
                      <button className="button button-secondary" onClick={() => navigate(-1)}>
                        <FaArrowLeft style={{ marginRight: '8px' }} />
                        Retour
                      </button>
                    </>
                  )}
                </div>
                <div className="card-content">
                  {/* Mobile View */}
                  <div className="mobile-section">
                    <div className="item">
                      <span className="item-label">Transaction ID:</span>
                      <span className="item-value">{achat.transaction_id}</span>
                    </div>
                    <div className="item">
                      <span className="item-label">Utilisateur:</span>
                      <span className="item-value">{achat.utilisateur_nom} {achat.utilisateur_prenoms}</span>
                    </div>
                    <div className="item">
                      <span className="item-label">Produit:</span>
                      <span className="item-value">{achat.produit_nom}</span>
                    </div>
                    {!achat.subscription_type && (
                      <div className="item">
                        <span className="item-label">Date achat:</span>
                        <span className="item-value">
                          {achat.date_achat ? new Date(achat.date_achat).toLocaleString() : 'N/A'}
                        </span>
                      </div>
                    )}
                    <div className="item">
                      <span className="item-label">Total:</span>
                      <span className="item-value green">{achat.total.toLocaleString()} FCFA</span>
                    </div>
                    {achat.subscription_type && (
                      <>
                        <div className="item">
                          <span className="item-label">Type abonnement:</span>
                          <span className="item-value blue">{achat.subscription_type}</span>
                        </div>
                        <div className="item">
                          <span className="item-label">Date de début:</span>
                          <span className="item-value">
                            {achat.datedebutabon ? new Date(achat.datedebutabon).toLocaleString() : 'N/A'}
                          </span>
                        </div>
                        <div className="item">
                          <span className="item-label">Date de fin:</span>
                          <span className="item-value">
                            {achat.datefinabon ? new Date(achat.datefinabon).toLocaleString() : 'N/A'}
                          </span>
                        </div>
                        <div className="item">
                          <span className="item-label">Statut abonnement:</span>
                          <span className="item-value badge">{achat.statutabon || 'Actif'}</span>
                        </div>
                      </>
                    )}
                    {/* <div className="qr-code-container">
                      <QRCodeCanvas value={qrCodeData} size={150} />
                    </div> */}

                  </div>

                  {/* Desktop View */}
                  <div className="desktop-section">
                    <div>
                      <div className="item">
                        <span className="item-label">Transaction ID:</span>
                        <span className="item-value">{achat.transaction_id}</span>
                      </div>
                      <div className="item">
                        <span className="item-label">Utilisateur:</span>
                        <span className="item-value">{achat.utilisateur_nom} {achat.utilisateur_prenoms}</span>
                      </div>
                      <div className="item">
                        <span className="item-label">Produit:</span>
                        <span className="item-value">{achat.produit_nom}</span>
                      </div>
                      {!achat.subscription_type && (
                        <div className="item">
                          <span className="item-label">Date achat:</span>
                          <span className="item-value">
                            {achat.date_achat ? new Date(achat.date_achat).toLocaleString() : 'N/A'}
                          </span>
                        </div>
                      )}
                      <div className="item">
                        <span className="item-label">Total:</span>
                        <span className="item-value green">{achat.total.toLocaleString()} FCFA</span>
                      </div>
                    </div>
                    <div>
                      {achat.subscription_type ? (
                        <>
                          <div className="item">
                            <span className="item-label">Type abonnement:</span>
                            <span className="item-value blue">{achat.subscription_type}</span>
                          </div>
                          <div className="item">
                            <span className="item-label">Date de début:</span>
                            <span className="item-value">
                              {achat.datedebutabon ? new Date(achat.datedebutabon).toLocaleString() : 'N/A'}
                            </span>
                          </div>
                          <div className="item">
                            <span className="item-label">Date de fin:</span>
                            <span className="item-value">
                              {achat.datefinabon ? new Date(achat.datefinabon).toLocaleString() : 'N/A'}
                            </span>
                          </div>
                          <div className="item">
                            <span className="item-label">Statut abonnement:</span>
                            <span className="item-value badge">{achat.statutabon || 'Actif'}</span>
                          </div>
                        </>
                      ) : (
                        <div style={{ color: '#6b7280' }}>Aucun abonnement associé</div>
                      )}
                      {/* <div className="qr-code-container">
                        <QRCodeCanvas value={qrCodeData} size={150} />
                      </div> */}
                    </div>
                   
                  </div>
                </div>
              </div>
            )}
          </div>

         
        </div>
      </div>
      </div>
      );
};

      export default InfoAchat;